/**
 * SGKE361A
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface AdconfirmTab {

    /**
     * 供給再開立会者区分コード
     */
    supplyresumptionTaiperDivcd?: string;
    /**
     * 立会人周知不可フラグ
     */
    witnessNotnoticeFlg?: string;
    /**
     * マイコンメーター有無フラグ
     */
    microcontrollermeterUmuFlg?: string;
    /**
     * 作業者メモ
     */
    sgyshMemo?: string;
}

